import React from 'react';
import Empty from 'src/components/Empty';
import { PATHS } from 'src/common/constants';
import { PAGINATION_KEYS } from 'src/store/slices/persistedUiSlice';
import { ServiceRequestDashboardTable } from 'src/pages/ServiceRequests/components/ServiceRequestDashboardTable';
import { ServiceRequestDashboardActions } from 'src/pages/ServiceRequests/components/ServiceRequestDashboardActions';
import { DownloadCSVAndPDFParserOverlay } from 'src/utils/DownloadCSVAndPDFParserOverlay/DownloadCSVAndPDFParserOverlay';
import 'src/pages/ServiceRequests/ServiceRequestDashBoardTable.scss';
import {
  useItemServiceRequestsOrchestrator,
  UseItemServiceRequestsOrchestratorReturn,
} from './CustomHooks/ItemServiceRequests/useItemServiceRequestsOrchestrator';

interface ItemServiceRequestProps {
  item: any;
}

const ItemServiceRequest = ({ item }: ItemServiceRequestProps) => {
  const itemId: string = item?.id ?? '';
  const navigateTo: string = PATHS.ITEMS_VIEW.replace(':id', itemId);
  const navLabel: string = item?.name ?? '';

  const orchestrator: UseItemServiceRequestsOrchestratorReturn =
    useItemServiceRequestsOrchestrator({ itemId, navigateTo, navLabel });

  const isInitialLoading: boolean =
    orchestrator.isLoading && orchestrator.serviceRequests.length === 0;

  const showEmpty: boolean =
    !orchestrator.isLoading &&
    orchestrator.visibleServiceRequests.length === 0;

  return (
    <div>
      <DownloadCSVAndPDFParserOverlay
        isOpen={orchestrator.isDownloadOverlayOpen}
        onClose={orchestrator.closeDownloadOverlay}
        onDownloadCSV={orchestrator.onDownloadCSV}
        isCSVLoading={orchestrator.isCSVLoading}
        onDownloadPDF={orchestrator.onDownloadPDF}
        isPDFLoading={orchestrator.isPDFLoading}
      />

      <ServiceRequestDashboardActions
        searchString={orchestrator.searchQuery}
        onChangeSearchString={orchestrator.setSearchQuery}
        showResolved={orchestrator.showResolvedOnly}
        onShowResolved={orchestrator.toggleShowResolved}
        onShowColumnSelectionDialog={orchestrator.openColumnSelectionDialog}
        onDownload={orchestrator.openDownloadOverlay}
        hideBulkActions={true}
      />

      {showEmpty ? (
        <Empty
          direction="ttb"
          headline="No service requests for this item"
          strapline="Service requests reported against this item will be listed here."
          image={null}
          searchIsActive={orchestrator.searchQuery !== ''}
        />
      ) : (
        <ServiceRequestDashboardTable
          serviceRequests={orchestrator.visibleServiceRequests}
          selectedServiceRequests={orchestrator.selectedIds}
          onSelectServiceRequest={orchestrator.toggleSelection}
          onSelectGroup={orchestrator.toggleSelectionBatch}
          onSelectAll={orchestrator.toggleSelectAllVisible}
          allSelected={orchestrator.allVisibleSelected}
          onDeleteGroup={() => undefined}
          onRemoveFromGroup={() => undefined}
          navigateTo={orchestrator.navigateTo}
          navLabel={orchestrator.navLabel}
          persistKey={`${PAGINATION_KEYS.itemServiceRequests}-${itemId}`}
          loading={isInitialLoading}
          showColumnSelectionDialog={orchestrator.showColumnSelectionDialog}
          onCloseColumnSelectionDialog={orchestrator.closeColumnSelectionDialog}
        />
      )}
    </div>
  );
};

export default ItemServiceRequest;